<template>
<div>
  <v-dialog v-model="dialog" width="550" persistent>

    <v-card v-if="roadSelector">
      <v-card-title>{{ $t('filters.load') }}</v-card-title>
      <v-card-text>
        <label>{{ $t("fleet.roads.selectRoad") }}</label>
        <v-select v-model="selectedRoad" @change="roadChange" :items="roads" :item-text="
              (item) =>
                item.firstLoading +
                ' - ' +
                item.lastUnloadng +
                ' (' +
                item.pointsCounter +
                ')'
            " item-value="id" dense outlined></v-select>

      </v-card-text>
      <v-card-actions class="d-flex justify-center">
        <v-btn :loading="loading" :disabled="loading" color="primary" @click="send" depressed>{{ $t('common.save') }}</v-btn>
        <v-btn :loading="loading" :disabled="loading" outlined @click="manualEntry" depressed>{{ $t('fleet.roads.manualEntry') }}</v-btn>
        <v-btn :loading="loading" :disabled="loading" outlined @click="close" depressed>{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>

    </v-card>

    <v-card v-else>
      <v-form ref="form" v-model="valid">
        <v-card-title>{{ $t('filters.load') }}</v-card-title>
        <v-card-text>
          <v-col cols="12">
            <v-row>
              <v-col class="pt-0">
                <label for="load">{{ $t('filters.load') }}</label>
                <LocationInput v-for="(location, index) in locations.loadingPlaces" :key="`load-${index}`" v-model="location.value" validation />

              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <DatePicker v-model="dateFrom.value" :label="$t('filters.loadDateFrom')" :rules="[validations.start]" />
              </v-col>
              <v-col cols="12" md="6">
                <DatePicker v-model="dateTo.value" :label="$t('filters.loadDateTo')" :min="dateFrom.value" :rules="[validations.start]" />
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn :loading="loading" :disabled="loading" color="primary" @click="send" depressed>{{ $t('common.save') }}</v-btn>
          <v-btn :loading="loading" :disabled="loading" outlined @click="close" depressed>{{ $t('common.cancel') }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Service from '@/services'
import moment from 'moment'
import {
  MAX,
  MIN,
  LOCATIONCROSS
} from '@/types/condition-types'
import {
  DATETIME
} from '@/types/filter-value-types'
import {
  createNewPlace,
  convertFilters
} from '@/utils/market'
import DatePicker from '@/components/forms/DatePicker'
import LocationInput from '@/components/forms/LocationInput'

export default {
  components: {
    LocationInput,
    DatePicker
  },
  data () {
    return {
      valid: true,
      roadSelector: false,
      roads: [],
      selectedRoad: null,
      dateFrom: {
        type: MIN,
        name: 'Start',
        valueType: DATETIME,
        value: null
      },
      locations: {
        type: LOCATIONCROSS,
        loadingPlaces: [
          {
            value: createNewPlace()
          }
        ],
        unloadingPlaces: [
          {
            value: createNewPlace()
          }
        ]
      },
      dateTo: {
        type: MAX,
        name: 'Start',
        valueType: DATETIME,
        value: null
      },
      locaton: null,
      dialog: false,
      phoneNumber: '',
      text: '',
      loading: false,
      item: null,
      validations: {
        onlyNaturalNumbers: (v) => v ? v > 0 : true,
        required: () => false,
        start: () => (this.dateFrom.value && this.dateFrom.value.length > 0 && this.dateTo.value && this.dateTo.value.length > 0) ? moment(this.dateFrom.value).unix() > moment(this.dateTo.value).unix() ? this.$t('validation.dateRange') : true : true

      }
    }
  },
  methods: {
    async roadChange (id) {
      const {
        data
      } = await Service.get('road/GetDetails', {
        roadId: id
      })
      this.locations.loadingPlaces[0].value = data.places[data.places.length - 1].location
      this.locations.loadingPlaces[0].value.range = 50

      var date = data.places[data.places.length - 1].dateTime
      this.dateFrom.value = date

      this.dateTo.value = new Date((new Date(date)).getTime() + 172800000).toISOString()

      this.roadSelector = false
    },
    async open (item) {
      this.dialog = true
      this.item = item
      const {
        data
      } = await Service.get('road/getroad', {
        vehicleId: item.id
      })
      this.roads = data.results
      if (this.roads.length > 0) {
        this.roadSelector = true
      }
    },
    manualEntry () {
      this.roadSelector = false
    },
    close () {
      console.log(this.dateFrom.value)
      this.roads = []
      this.roadSelector = false
      this.item = null
      this.dialog = false
      this.dateFrom.value = null
      this.dateTo.value = null
      this.selectedRoad = null
      this.locations.loadingPlaces = [
        {
          value: createNewPlace()
        }
      ]
    },
    async send () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.loading = true

      try {
        const conditions = {
          minStart: this.dateFrom,
          maxStart: this.dateTo,
          locations: {
            ...this.locations,
            loadingPlaces: this.locations.loadingPlaces.map(i => ({
              ...i.value
            }))
          }
        }
        console.log(conditions)
        const filters = convertFilters(this.$store.getters['market/orderType'], conditions)
        const {
          data
        } = await Service.post('Filter/CreateForVehicle', {
          vehicleId: this.item.id,
          conditions: filters.conditions
        })

        this.$router.push({
          name: 'LoadsFilter',
          params: {
            id: data
          }
        })
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style></style>
